// @ts-nocheck
/* eslint-disable */
import { makeEvent } from "~/lib/signals";
import { pointInPolygonTest } from "~/util/intersect";
import SceneConst from "~/scene/common/const";
import Scene from "~/scene";
import { store } from "~/state/store";
import { watch, watchCoordinates } from "~/state/util";
import { Unsubscribe } from "redux";

/**
 * Generuje signal:
 * @signal state-area-check Pri pohybu mapy vraci seznam definovanych statu a jestli se nachazi na obrazovce.
 */
export default class StateArea {
	constructor() {
		const wt = watch(store.getState, "map", watchCoordinates);

		this._storeUnsubscribe = store.subscribe(wt((newMap, oldMap) => {
			if (
				newMap.longitude !== oldMap.longitude
				|| newMap.latitude !== oldMap.latitude
				|| newMap.zoom !== oldMap.zoom
			) {
				this._mapRedraw();
			}
		}));
		this._redrawTimeoutID = null;
		this._redrawTimeout = 100;
		this._states = SceneConst.statesArea;
		this._lastCheck = null;

		Scene.addListener("provider-change", function(event) {
			var data = event.data;

			// pri prechodu na 3d - tohle hazelo chybu, protoze uvnitr checkState byly operace nad coords
			if (data.newProvider == "m3d") {
				if (this._redrawTimeoutID) {
					clearTimeout(this._redrawTimeoutID);
					this._redrawTimeoutID = null;
				}
			}
		}, this);
	}

	resend() {
		this._mapRedraw();
	}

	_mapRedraw() {
		if (Scene.isMapActive()) {
			if (this._redrawTimeoutID) {
				clearTimeout(this._redrawTimeoutID);
				this._redrawTimeoutID = null;
			}

			this._redrawTimeoutID = setTimeout(this._checkStates.bind(this), this._redrawTimeout);
		}
	}

	/**
	 * Otestovani, jestli dany stat je v pruhledu obrazovky.
	 * Nejdrive test stredu mapy na polygon statu, jinak jestli jeden z jeho bodu
	 * je v pruhledu obrazovky.
	 */
	_checkStates() {
		this._lastCheck = this.checkStates();

		makeEvent("state-area-check", this, this._lastCheck);
	}

	checkStates() {
		const { longitude, latitude } = store.getState().map;
		const mapCenter = Scene.coordsFromWGS84(longitude, latitude);
		const output = {};
		const states = this.getAvailableStates();

		Object.keys(states).forEach(stateKey => {
			output[states[stateKey]] = {
				find: false,
			};
		});

		const coordsCheck = this.checkCoords(mapCenter);

		if (coordsCheck && coordsCheck in output) {
			output[coordsCheck].find = true;
		}

		return output;
	}

	lastCheck() {
		if (!this._lastCheck) {
			this._checkStates();
		}

		return this._lastCheck;
	}

	/**
	 * Vraci seznam dostupnych statu.
	 * @return {Array}
	 */
	getAvailableStates() {
		return Object.keys(this._states);
	}

	/**
	 * Otestuje souradnice, jestli patri do uzemi nejakeho statu.
	 * @param  {SceneCoords} c
	 * @return {String|Object} bud vraci zkraktu statu nebo null
	 */
	checkCoords(coords) {
		if (!coords) {
			return null;
		}

		// musime prevest na UTM33
		const wgs84 = coords.toWGS84();
		const states = this.getAvailableStates();

		for (let ind = 0, max = states.length; ind < max; ind++) {
			const stateId = states[ind];
			const state = this._states[stateId];

			if (pointInPolygonTest(wgs84, state.polygon)) {
				return stateId;
			}
		}

		return null;
	}
};
